export default "__VITE_ASSET__DYadxzJ1__"